import { toastSuccess } from './toasts';

const copyLinkToClipboard = (link: string) => {
  navigator.clipboard
    .writeText(link)
    .then(() => {
      toastSuccess('Texto copiado al portapapeles');
    })
    .catch((err) => {
      console.error('Error al copiar al portapapeles: ', err);
    });
};

export default copyLinkToClipboard;
